import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { AppMainComponent } from './app.main.component';
import { AppNotfoundComponent } from './shared/pages/app.notfound.component';
import { AppErrorComponent } from './shared/pages/app.error.component';
import { AppAccessdeniedComponent } from './shared/pages/app.accessdenied.component';
import { AppAccountPendingComponent } from './shared/pages/app.account-pending.component';
import { AppLoginComponent } from './shared/pages/app.login.component';
import { MsalGuard } from '@azure/msal-angular';
import { accountPendingGuard, userRegisteredGuard } from './guards/user-registered.guard';

@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '',
                component: AppMainComponent,
                loadChildren: () => import('./modules/landing/landing.module').then(m => m.LandingModule),
            },
            {
                path: 'member',
                component: AppMainComponent,
                loadChildren: () => import('./modules/member/member.module').then(m => m.MemberModule),
                canActivate: [MsalGuard, userRegisteredGuard]
            },
            {
                path: 'players',
                component: AppMainComponent,
                loadChildren: () => import('./modules/players/players.module').then(m => m.PlayersModule),
                canActivate: [MsalGuard, userRegisteredGuard]
            },
            {
                path: 'teams',
                component: AppMainComponent,
                loadChildren: () => import('./modules/teams/teams.module').then(m => m.TeamsModule),
                canActivate: [MsalGuard, userRegisteredGuard]
            },
            { path: 'error', component: AppErrorComponent },
            { path: 'accessdenied', component: AppAccessdeniedComponent },
            { path: 'account-pending', component: AppAccountPendingComponent, canActivate: [MsalGuard, accountPendingGuard] },
            { path: 'notfound', component: AppNotfoundComponent },
            { path: 'login', component: AppLoginComponent },
            { path: '**', redirectTo: '/notfound' },
        ], { scrollPositionRestoration: 'enabled', useHash: false })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }